import React from 'react';

const Loading = (props) => {
  const { withFullBatchText = false, text = '' } = props;
  return (
    <>
      <div className="row justify-content-center align-items-center">
        <div className={withFullBatchText ? 'overlay-with-text' : 'overlay'} />
        <div id="preloader">
          <div id={withFullBatchText ? 'loader-with-text' : 'loader'} data-testid="loader" />
          {withFullBatchText && <span className="loading-spinner-text">{text}</span>}
        </div>
      </div>
    </>
  );
};

export default Loading;
